// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"c3a6d6ef","75":"075c54bc","80":"08c6d50a","104":"075c54bc","164":"90db10a2","651":"075c54bc","745":"820562cf"}[chunkId] + ".chunk.css";
};